import React from 'react';
import {BaseIcon, iconDefaultProps, iconPropTypes} from './base-icon';
export const ProgressRegistrationIcon = ({...props}) => (
	<BaseIcon {...props}>
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M10 0C9.64734 0 9.29874 0.0182791 8.95514 0.0539789C8.62554 0.0882236 8.38611 0.383175 8.42036 0.712772C8.4546 1.04237 8.74955 1.2818 9.07915 1.24755C9.38163 1.21613 9.68883 1.2 10 1.2C14.8601 1.2 18.8 5.13989 18.8 10C18.8 14.8601 14.8601 18.8 10 18.8C9.68883 18.8 9.38163 18.7839 9.07915 18.7524C8.74955 18.7182 8.4546 18.9576 8.42036 19.2872C8.38611 19.6168 8.62554 19.9118 8.95514 19.946C9.29874 19.9817 9.64734 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0Z"
				fill="#4C4C58"
			/>
			<path
				d="M6.41999 1.95856C6.72263 1.82361 6.85857 1.46886 6.72362 1.16622C6.58867 0.863574 6.23392 0.727633 5.93128 0.862586C5.28928 1.14886 4.68317 1.50071 4.12144 1.90952C3.85352 2.10451 3.79439 2.47978 3.98938 2.74771C4.18437 3.01564 4.55964 3.07476 4.82757 2.87977C5.32212 2.51985 5.85544 2.2103 6.41999 1.95856Z"
				fill="#4C4C58"
			/>
			<path
				d="M2.87977 4.82757C3.07476 4.55964 3.01564 4.18437 2.74771 3.98938C2.47978 3.79439 2.10451 3.85351 1.90952 4.12144C1.50071 4.68317 1.14886 5.28928 0.862587 5.93128C0.727633 6.23392 0.863575 6.58867 1.16622 6.72362C1.46887 6.85857 1.82361 6.72263 1.95856 6.41999C2.2103 5.85544 2.51985 5.32212 2.87977 4.82757Z"
				fill="#4C4C58"
			/>
			<path
				d="M1.24755 9.07915C1.2818 8.74955 1.04237 8.4546 0.712772 8.42036C0.383175 8.38611 0.0882236 8.62554 0.0539789 8.95514C0.0182791 9.29874 0 9.64734 0 10C0 10.3527 0.0182791 10.7013 0.0539789 11.0449C0.0882236 11.3745 0.383175 11.6139 0.712772 11.5796C1.04237 11.5454 1.2818 11.2504 1.24755 10.9208C1.21613 10.6184 1.2 10.3112 1.2 10C1.2 9.68883 1.21613 9.38163 1.24755 9.07915Z"
				fill="#4C4C58"
			/>
			<path
				d="M1.95856 13.58C1.82361 13.2774 1.46886 13.1414 1.16622 13.2764C0.863574 13.4113 0.727633 13.7661 0.862586 14.0687C1.14886 14.7107 1.50071 15.3168 1.90952 15.8786C2.10451 16.1465 2.47978 16.2056 2.74771 16.0106C3.01564 15.8156 3.07476 15.4404 2.87977 15.1724C2.51985 14.6779 2.2103 14.1446 1.95856 13.58Z"
				fill="#4C4C58"
			/>
			<path
				d="M4.82757 17.1202C4.55964 16.9252 4.18437 16.9844 3.98938 17.2523C3.79439 17.5202 3.85351 17.8955 4.12144 18.0905C4.68317 18.4993 5.28928 18.8511 5.93128 19.1374C6.23392 19.2724 6.58867 19.1364 6.72362 18.8338C6.85857 18.5311 6.72263 18.1764 6.41999 18.0414C5.85544 17.7897 5.32212 17.4802 4.82757 17.1202Z"
				fill="#4C4C58"
			/>
			<path
				d="M5.07575 10.5757C5.31007 10.3414 5.68997 10.3414 5.92428 10.5757L8.00003 12.6515L14.0758 6.57576C14.3101 6.34145 14.69 6.34145 14.9243 6.57576C15.1586 6.81007 15.1586 7.18997 14.9243 7.42429L8.42429 13.9243C8.18997 14.1586 7.81007 14.1586 7.57576 13.9243L7.57308 13.9216L5.07575 11.4243C4.84144 11.1899 4.84144 10.8101 5.07575 10.5757Z"
				fill="#4C4C58"
			/>
		</svg>
	</BaseIcon>
);

ProgressRegistrationIcon.propTypes = iconPropTypes;
ProgressRegistrationIcon.defaultProps = iconDefaultProps;
